import { render, staticRenderFns } from "./NewCustomCampaignModal.vue?vue&type=template&id=22427b5c&scoped=true"
import script from "./NewCustomCampaignModal.vue?vue&type=script&lang=js"
export * from "./NewCustomCampaignModal.vue?vue&type=script&lang=js"
import style0 from "./NewCustomCampaignModal.vue?vue&type=style&index=0&id=22427b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22427b5c",
  null
  
)

export default component.exports